export default __webpack_public_path__ + "static/cspo-f7b3a354bc279a5a2f639d6f9cd89a52.png";